import { render, staticRenderFns } from "./NhlGoaliesSection.vue?vue&type=template&id=7e43cff4&scoped=true"
import script from "./NhlGoaliesSection.vue?vue&type=script&lang=js"
export * from "./NhlGoaliesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e43cff4",
  null
  
)

export default component.exports